import metricTypeCheckers from '../../../../../../types/metricTypeCheckers';
import updateMetric from '../../../../../../api/metrics/updateMetric';
import updateCompoundMetric from '../../../../../../api/compoundMetrics/updateCompoundMetric';
import { useCallback, useContext } from 'react';
import { useGetMetric } from '../../../../../GoalShow/useGoalData';
import CurrentUserContext from '../../../../../../contexts/CurrentUserContext';
import AccountPickerContext from '../../../../../../contexts/AccountPickerContext';
import getUsageCount from './getUsageCount';
import { FindAndReplace } from '../../types';
import MetricUsageLookupContext from '../../../../../../contexts/MetricUsageLookupContext';

const useArchiveUnusedMetric = () => {
  const { selectedAccountId } = useContext(AccountPickerContext);
  const { id: currentUserId } = useContext(CurrentUserContext);
  const { metricLookup } = useContext(MetricUsageLookupContext);
  const getMetric = useGetMetric();

  const archiveUnusedMetric = useCallback(
    (metricReceipt: FindAndReplace.MetricReceipt) => {
      const metric = getMetric(metricReceipt.findMetricId);

      const usageCount = getUsageCount(metricReceipt.affectedContentIds);
      const currentUsage = metricLookup[metricReceipt.findMetricId];
      const currentUsageCount = currentUsage
        ? currentUsage?.usageCount - currentUsage?.reports.length
        : 0;

      if (currentUsageCount !== 0 && usageCount !== currentUsageCount) {
        return Promise.resolve();
      }

      if (metricTypeCheckers.isNormalMetric(metric)) {
        const newMetric = {
          ...metric,
          updatedBy: currentUserId,
          status: 'archived' as 'archived',
        };
        return updateMetric(metric.id, newMetric, selectedAccountId);
      } else if (metricTypeCheckers.isCompoundMetric(metric)) {
        const newMetric = {
          ...metric,
          updatedBy: currentUserId,
          status: 'archived' as 'archived',
        };
        return updateCompoundMetric(metric.id, newMetric, selectedAccountId);
      }
    },
    [currentUserId, getMetric, metricLookup, selectedAccountId],
  );

  return archiveUnusedMetric;
};

export default useArchiveUnusedMetric;
